export default __webpack_public_path__ + "static/media/BAA.49f7f87b.pdf";